import React from "react";
import { QRCodeCanvas } from "qrcode.react"; // Adjust the import to use QRCodeCanvas or QRCodeSVG
import "./AssociatedMembersQR.css";

function AssociatedMembersQR({ value, size = 128, header }) {
  return (
    <div className="qr-code-section">
      {header && <h3 className="qr-code-header">{header}</h3>}
      <QRCodeCanvas
        value={value}
        size={size}
      />{" "}
      {/* Use QRCodeCanvas instead */}
    </div>
  );
}

export default AssociatedMembersQR;
